import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    successTitle: {
        id: 'notifications.transfer.success.title',
        defaultMessage: 'Successful transfer',
    },
    successFrom: {
        id: 'notifications.transfer.success.from',
        defaultMessage: 'From:',
    },
    successTo: {
        id: 'notifications.transfer.success.to',
        defaultMessage: 'To:',
    },
    successAmount: {
        id: 'notifications.transfer.success.amount',
        defaultMessage: 'Amount:',
    },
    pendingTitle: {
        id: 'notifications.transfer.pending.title',
        defaultMessage: 'Transfer is pending',
    },
    pendingContent: {
        id: 'notifications.transfer.pending.content',
        defaultMessage: 'Confirming the transfer transaction, please wait.',
    },
    errorTitle: {
        id: 'notifications.transfer.error.title',
        defaultMessage: 'Error send',
    },
    errorContent: {
        id: 'notifications.transfer.error.content',
        defaultMessage: 'The transfer transaction cannot be completed.',
    },
    errorButton: {
        id: 'notifications.transfer.error.button',
        defaultMessage: 'Try again',
    },
    spot: {
        id: 'notifications.transfer.spot',
        defaultMessage: 'Spot',
    },
    wallet: {
        id: 'notifications.transfer.wallet',
        defaultMessage: 'Wallet',
    },
    derivatives: {
        id: 'notifications.transfer.derivatives',
        defaultMessage: 'Derivatives',
    },
})
